module.exports = __webpack_public_path__ + "img/IVAN.9aae208a.png";